// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WXbL","toggleWrap":"styles_toggleWrap__bAWey","content":"styles_content__1u7Fg","selectAreaCode":"styles_selectAreaCode__1iKG_"};